module.exports = __webpack_public_path__ + "img/hot.e14cae72.gif";